module.exports = __webpack_public_path__ + "static/the-last-lion-box-set-b4c3ba505946b794533ddb5230fd1cd5.jpg";